import CloseIcon from '@mui/icons-material/Close';
import { Alert, Collapse, IconButton } from "@mui/material";
import { useEffect, useState } from 'react';

const ErrorAlert = ({ open, handleClose, severity, message  }) => {
    const [isDismissed, setIsDismissed] = useState(false);

    useEffect(() => {
        setIsDismissed(false);
    }, [open, message]);

    const closeAlert = () => {
        setIsDismissed(true);
        if (handleClose) {
            handleClose();
        }
    };

    return (
        <Collapse in={Boolean(open) && !isDismissed}>
            <Alert severity={severity}
                   action={
                       <IconButton
                           aria-label="close"
                           color="inherit"
                           size="small"
                           onClick={closeAlert}
                       >
                           <CloseIcon fontSize="inherit" />
                       </IconButton>
                   }>
               {message}
            </Alert>
        </Collapse>
    );
};

export default ErrorAlert;
